const global = window

// Helper pour comparer les valeurs (avec support arrays, booleans, nombres et strings)
function valuesMatch(val1, val2) {
    if (val1 === val2) return true;
    if (val1 == val2) return true;
    if (Array.isArray(val1)) {
        return val1.some(v => valuesMatch(v, val2));
    }
    if (val1 === true && (val2 === 'true' || val2 === '1' || val2 === 1)) return true;
    if (val1 === false && (val2 === 'false' || val2 === '0' || val2 === 0)) return true;
    if (val2 === true && (val1 === 'true' || val1 === '1' || val1 === 1)) return true;
    if (val2 === false && (val1 === 'false' || val1 === '0' || val1 === 0)) return true;
    return false;
}

// Support de conditions d'affichages
inputs.behavior.cond = function (data, name, niceName, type, input, parent, inputWindow) {
    if (data.cond) {
        console.group(`[COND.JS] Registering cond for "${niceName}" (name: "${name}", type: "${type}")`);
        console.log('[COND.JS] Raw data.cond:', data.cond);

        // fix data: ensure data.cond is an array of groups
        if (!(data.cond instanceof Array)) {
            data.cond = [data.cond]
        }

        if (!(data.cond[0] instanceof Array)) {
            data.cond = [data.cond]
        }

        // Check if data.cond[0] is a condition tuple (e.g. ['field', '==', 'val']) rather than a group
        if (data.cond[0] instanceof Array && typeof data.cond[0][0] === 'string' && (data.cond[0][1] === '==' || data.cond[0][1] === '!=' || data.cond[0][1] === '<' || data.cond[0][1] === '>' || data.cond[0][1] === '<=' || data.cond[0][1] === '>=')) {
            data.cond = [data.cond]
        }

        console.log('[COND.JS] Normalized data.cond structure:', data.cond);

        // find fields & parse/merge conditions
        const fields = {}
        $.each(data.cond, function (index, groupOr) {
            const parsedGroup = []
            const fieldIndexMap = {}

            $.each(groupOr, function (indexb, groupAnd) {
                if (typeof groupAnd == 'string') {
                    const parseCond = groupAnd.split(' ')
                    groupAnd = {
                        field: parseCond[0],
                        operator: parseCond[1],
                        val: parseCond.slice(2).join(' '),
                    }
                }
                else if (Array.isArray(groupAnd) && groupAnd.length >= 2) {
                    groupAnd = {
                        field: groupAnd[0],
                        operator: groupAnd[1],
                        val: groupAnd[2],
                    }
                }

                if (!groupAnd || !groupAnd.field) return

                fields[groupAnd.field] = groupAnd.field

                // Fix val as array
                if (!Array.isArray(groupAnd.val) || groupAnd.val === null) {
                    groupAnd.val = groupAnd.val !== undefined ? [groupAnd.val] : []
                }

                // Merge multiple conditions on the same field with '==' or '!=' within the same group
                // E.g. (field == a) AND (field == b) is impossible -> user means (field == a OR field == b)
                const key = groupAnd.field + '__' + groupAnd.operator
                if (fieldIndexMap[key] !== undefined && (groupAnd.operator === '==' || groupAnd.operator === '!=')) {
                    const existing = parsedGroup[fieldIndexMap[key]]
                    groupAnd.val.forEach(v => {
                        if (!existing.val.includes(v)) {
                            existing.val.push(v)
                        }
                    })
                } else {
                    fieldIndexMap[key] = parsedGroup.length
                    parsedGroup.push(groupAnd)
                }
            })

            data.cond[index] = parsedGroup
        })

        console.log('[COND.JS] Parsed & merged data.cond:', data.cond);
        console.log('[COND.JS] Extracted dependency fields:', fields);
        console.log('[COND.JS] inputWindow:', inputWindow && inputWindow.length ? inputWindow[0] : inputWindow, 'behavkey:', inputWindow.data('behavkey'));
        console.groupEnd();

        data.applyCond = function (changedField) {
            changedField = $(changedField)
            const pf = changedField.length ? changedField.closest('[data-api], .window, body') : input.closest('[data-api], .window, body')

            console.group(`[COND.JS] >>> applyCond() for target: "${niceName}"`);
            console.log('[COND.JS] Triggered by changedField:', {
                tag: changedField.prop('tagName'),
                id: changedField.attr('id'),
                name: changedField.attr('name'),
                dataId: changedField.data('id'),
                val: changedField.val(),
                element: changedField.get(0)
            });
            console.log('[COND.JS] Context container pf:', {
                tag: pf.prop('tagName'),
                id: pf.attr('id'),
                class: pf.attr('class'),
                element: pf.get(0)
            });

            const allFormData = global.getFormData ? global.getFormData(pf, true) : null;
            console.log('[COND.JS] Available getFormData(pf, true) keys:', allFormData ? Object.keys(allFormData) : 'N/A');

            let testOr = false
            $.each(data.cond, function (indexOr, groupOr) {
                let testAnd = true
                console.log(`[COND.JS] --- Evaluating OR Group #${indexOr + 1} (${groupOr.length} condition(s)) ---`);

                $.each(groupOr, function (indexAnd, groupAnd) {
                    let value = global.getFieldData(groupAnd.field, pf)
                    let testCond = 0

                    // fix val data
                    if (!Array.isArray(groupAnd.val) || groupAnd.val === null) {
                        groupAnd.val = [groupAnd.val]
                    }

                    // Undefined value
                    if (value == undefined || value === '') {
                        value = null;
                    }

                    // Fallback inspection if value is null
                    let directEl = pf.find('[data-id="' + groupAnd.field + '"], [name="' + groupAnd.field + '"], #' + groupAnd.field);
                    let directVal = directEl.length ? (directEl.is(':checkbox') ? (directEl.is(':checked') ? 1 : 0) : directEl.val()) : undefined;

                    // tests data
                    $.each(groupAnd.val, function (i2, testVal) {
                        if (testVal === '') testVal = null;

                        switch (groupAnd.operator) {
                        case '>':
                            if (value <= testVal) testCond = -1
                            break
                        case '<':
                            if (value >= testVal) testCond = -1
                            break
                        case '>=':
                            if (value < testVal) testCond = -1
                            break
                        case '<=':
                            if (value > testVal) testCond = -1
                            break
                        case '!=':
                            if (valuesMatch(value, testVal)) testCond = -1
                            break
                        case '==':
                        default:
                            if (valuesMatch(value, testVal)) testCond = 1
                        }
                    })

                    if (testCond == 0) {
                        if (groupAnd.operator == '==') testCond = -1
                        else testCond = 1
                    }

                    console.log(`[COND.JS] [Group ${indexOr + 1} | Cond ${indexAnd + 1}] Field "${groupAnd.field}":`, {
                        requiredCondition: `${groupAnd.field} ${groupAnd.operator} ${JSON.stringify(groupAnd.val)}`,
                        valueFromGetFieldData: value,
                        typeOfValue: typeof value,
                        directElementFound: directEl.length ? directEl.get(0) : 'NOT FOUND IN pf',
                        directElementVal: directVal,
                        testCondResult: testCond,
                        status: testCond === 1 ? 'PASS (matches)' : 'FAIL (does not match)'
                    });

                    // one test fail, the and test fail
                    if (testCond == -1) testAnd = false
                })

                console.log(`[COND.JS] Group #${indexOr + 1} AND result:`, testAnd ? 'TRUE' : 'FALSE');

                // one test success, the or test success
                if (testAnd) testOr = true
            })

            console.log(`[COND.JS] === FINAL EVALUATION for "${niceName}": testOr = ${testOr} (${testOr ? 'SHOW' : 'HIDE'}) ===`);

            // apply state
            let needChange = false;
            if (testOr) {
                const labelCol = pf.find('.col--label--' + niceName);
                const fieldCol = pf.find('.col--field--' + niceName);
                const tabEl = pf.find('.' + niceName + '-tab');

                console.log(`[COND.JS] SHOW action applied to "${niceName}":`, {
                    inputDisabledBefore: input.is(':disabled'),
                    labelColCount: labelCol.length,
                    fieldColCount: fieldCol.length,
                    tabCount: tabEl.length
                });

                if (input.is(':disabled') || input.hasClass('disabled')) needChange = true
                if (!data.disabled) {
                    input.removeAttr('disabled').removeClass('disabled');
                    parent.find('.xdsoft_disabled').removeClass('xdsoft_disabled');
                }
                if (!input.hasClass('tabs__pane')) {
                	// input.show()
                }
                input.removeClass('hidden');
                labelCol.show()
                fieldCol.show()
                tabEl.show().css('display', 'inline-block').removeClass('hidden')
                if (
                    tabEl.length
                    && tabEl.find('li').length > 1
                ) {
                    pf.find('.' + niceName).hide()
                }
            } else {
                const labelCol = pf.find('.col--label--' + niceName);
                const fieldCol = pf.find('.col--field--' + niceName);
                const tabEl = pf.find('.' + niceName + '-tab');

                console.log(`[COND.JS] HIDE action applied to "${niceName}":`, {
                    inputDisabledBefore: input.is(':disabled'),
                    condEffect: data.condEffect,
                    labelColCount: labelCol.length,
                    fieldColCount: fieldCol.length,
                    tabCount: tabEl.length
                });

                if (!input.is(':disabled') && !input.hasClass('disabled')) needChange = true
                input.attr('disabled', 'disabled').addClass('disabled');
                if (data.condEffect != 'disabled') {
                    // input.hide()
                    labelCol.hide()
                    fieldCol.hide()
                    tabEl.hide().addClass('hidden')
                }
                if (tabEl.hasClass('ui-tabs-active')) {
                    inputs.fn.tabs.set(tabEl.closest('.tabs'), tabEl.parent().find('> li').not('.ui-tabs-active').first());
                }
                if (tabEl.hasClass('steps__btn')) tabEl.show();
            }

            console.log(`[COND.JS] needChange for "${niceName}":`, needChange);
            console.groupEnd();

            if (needChange && input) {
                input.change();
            }
        }

        data.condBinding = function(target) {
            console.group(`[COND.JS] condBinding() for field "${niceName}" on target:`, target && target.length ? target[0] : target);
            let anyBound = false;
            $.each(fields, function (index, field) {
                let inputTarget = target.find('[data-id="' + field + '"]')
                console.log(`[COND.JS] Looking for dependency "${field}":`, {
                    byDataIdCount: inputTarget.length,
                    byNameCount: target.find('[name="' + field + '"]').length,
                    byIdCount: target.find('#' + field).length,
                    globalDataIdCount: $('[data-id="' + field + '"]').length,
                    element: inputTarget.length ? inputTarget.get(0) : null
                });

                if (!inputTarget.length) {
                    console.warn(`[COND.JS] WARNING: Dependency field "${field}" was NOT found by [data-id="${field}"] in target!`);
                } else {
                    anyBound = true;
                }

	            inputTarget.change(function () {
                    console.log(`[COND.JS] Event CHANGE fired on dependency "${field}" for target "${niceName}"`);
	                data.applyCond(this)
	            }).keyup(function () {
	                global.noQ = true;
	                inputTarget.data('noQ', true);
	                data.applyCond(this)
	                inputTarget.removeData('noQ');
	                global.noQ = false;
	            })
	            global.noQ = true;
	            inputTarget.data('noQ', true);
                console.log(`[COND.JS] Triggering initial .change() on dependency "${field}" for target "${niceName}" (found: ${inputTarget.length})`);
	            inputTarget.change()
	            inputTarget.removeData('noQ');
	            global.noQ = false;
	        })
            if (!anyBound) {
                console.warn(`[COND.JS] WARNING: No dependency was found in target for "${niceName}". Initial applyCond will NOT be triggered by change event.`);
            }
            console.groupEnd();
        }

        data.condBinding(inputWindow);
        BEHAV.add(data.condBinding, inputWindow.data('behavkey'));
    }
    return data
}
